import { useEffect, useMemo } from 'react';

import { Deferred } from '../utility/defer';

export function useDeferredData<T>(data: null | T): Deferred<T>;
export function useDeferredData<T>(data: T, isFetching: boolean): Deferred<T | null>;
export function useDeferredData<T>(data: null | T, isFetching?: boolean) {
    const deferred = useMemo(() => new Deferred<T>(), []);

    useEffect(() => {
        const strategy = isFetching !== undefined ? 'flag' : 'inferred';

        const strategies: Record<typeof strategy, boolean> = {
            'flag': isFetching === false,
            'inferred': data !== null,
        };

        const conditionMatches = strategies[strategy];

        if (conditionMatches) {
            deferred.resolve(data as T);
    
            return () => deferred.reset();
        }
    }, [data, deferred, isFetching]);

    return deferred;
}
